/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import React from "react"
import { Helmet } from "react-helmet"

export const wrapRootElement = ({ element }) => (
  <>
    <Helmet>
      <meta
        name="google-site-verification"
        content="E_eZ6Zooi8zY7NuK4-7S1XQf58gV4uMZJxEcD-5LDpk"
      />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&family=Roboto+Slab:wght@700&display=swap"
        rel="stylesheet"
      />
    </Helmet>
    {element}
  </>
)
